module.exports = __webpack_public_path__ + "img/11-accompagnements.60f6b73e.jpg";